import * as go from 'gojs/release/go-module';
import { alphaSort } from 'vet-bones/utils';

import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  MappingLink,
  ResourceNode,
} from 'src/containers/ProjectDiagram/types/diagram';
import { isLink } from 'src/containers/ProjectDiagram/utils/graphObject';

const mappingLinkSort = alphaSort((item: MappingLink) => item.data.text);

export const getMappingsForResource = (node: ResourceNode) => {
  return new go.Set(node?.linksConnected)
    .toArray()
    .filter((l): l is MappingLink =>
      isLink<MappingLink>(l, LinkCategory.MAPPING)
    )
    .sort(mappingLinkSort);
};
